// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.friends {
  width: 112px;
  height: 80px;
  object-fit: contain;
}

.earned {
  width: 80px;
  height: 80px;
  object-fit: contain;
}

.counter {
  font-size: 1.5rem;
  font-weight: bold;
}

.refer-input {
  height: 48px;
  border: none;
  max-width: 140px;
  text-align: center;
  font-size: 20px;
  font-weight: bold;
}

textarea:focus,
input:focus {
  outline: none;
}`, "",{"version":3,"sources":["webpack://./src/app/pages/refer-a-friend/raf-overview/raf-overview.component.scss"],"names":[],"mappings":"AAAA;EACI,YAAA;EACA,YAAA;EACA,mBAAA;AACJ;;AAEA;EACI,WAAA;EACA,YAAA;EACA,mBAAA;AACJ;;AAEA;EACI,iBAAA;EACA,iBAAA;AACJ;;AAEA;EACI,YAAA;EACA,YAAA;EACA,gBAAA;EACA,kBAAA;EACA,eAAA;EACA,iBAAA;AACJ;;AAEA;;EAEI,aAAA;AACJ","sourcesContent":[".friends {\r\n    width: 112px;\r\n    height: 80px;\r\n    object-fit: contain;\r\n}\r\n\r\n.earned {\r\n    width: 80px;\r\n    height: 80px;\r\n    object-fit: contain;\r\n}\r\n\r\n.counter {\r\n    font-size: 1.5rem;\r\n    font-weight: bold;\r\n}\r\n\r\n.refer-input {\r\n    height: 48px;\r\n    border: none;\r\n    max-width: 140px;\r\n    text-align: center;\r\n    font-size: 20px;\r\n    font-weight: bold;\r\n}\r\n\r\ntextarea:focus,\r\ninput:focus {\r\n    outline: none;\r\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
